<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [draggable]="true"
  [resizable]="false"
  styleClass="edit-timer-dialog"
  ngClass="edit-timer-dialog"
  header="Edit Timer"
  (onHide)="onHide()"
>
  <form [formGroup]="editForm" (ngSubmit)="onSubmit()">
    <div class="form-container">
      <!-- Project Field -->
      <div class="form-group">
        <label for="project" class="required-field">Project</label>
        <p-autoComplete
          formControlName="project"
          placeholder="Search Project"
          [dropdown]="true"
          [suggestions]="projectOptions"
          (completeMethod)="autoCompleteProjects($event)"
          field="name"
          [minLength]="0"
          [completeOnFocus]="true"
          (onSelect)="onProjectChange($event)"
          emptyMessage="No projects found."
          styleClass="w-full"
          appendTo="body"
        >
          <ng-template let-project pTemplate="item">
            <div class="autocomplete-item">
              <i class="pi pi-building"></i>
              <span>{{ project.name }}</span>
            </div>
          </ng-template>
        </p-autoComplete>
        <div
          class="error-message"
          *ngIf="submitted && editForm.get('project')?.hasError('required')"
        >
          Please select a project
        </div>
      </div>

      <!-- Task Field -->
      <div class="form-group">
        <label for="task" class="required-field">Task</label>
        <p-autoComplete
          formControlName="task"
          placeholder="Search Task"
          [dropdown]="true"
          [suggestions]="taskOptions"
          (completeMethod)="autoCompleteTasks($event)"
          field="title"
          [minLength]="0"
          [completeOnFocus]="true"
          emptyMessage="No tasks found. Select a project first."
          [disabled]="!editForm.get('project')?.value"
          styleClass="w-full"
          appendTo="body"
        >
          <ng-template let-task pTemplate="item">
            <div class="autocomplete-item">
              <i class="pi pi-check-square"></i>
              <span class="task-number">{{ task.uniqueTaskID }}</span>
              <span>{{ task.title }}</span>
            </div>
          </ng-template>
        </p-autoComplete>
        <div
          class="error-message"
          *ngIf="submitted && editForm.get('task')?.hasError('required')"
        >
          Please select a task
        </div>
      </div>

      <!-- Info Message -->
      <div class="info-message">
        <i class="pi pi-info-circle"></i>
        <span
          >Note: This will update the timer's project and task. Accumulated time
          will be preserved.</span
        >
      </div>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-secondary"
        (click)="closeModal()"
        [disabled]="isLoading"
      >
        Cancel
      </button>
      <button
        type="button"
        class="btn btn-primary"
        (click)="onSubmit()"
        [disabled]="isLoading"
      >
        <i class="pi pi-spin pi-spinner" *ngIf="isLoading"></i>
        <span *ngIf="!isLoading">Save Changes</span>
        <span *ngIf="isLoading">Saving...</span>
      </button>
    </div>
  </ng-template>
</p-dialog>
